import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';
import { CardContainer } from './styles';

export enum CardType {
  Trade = 'trade',
  Finance = 'finance'
}

type OwnProps = {
  card: CardType;
};

const LoadingBlock = createComponent('div', {
  className: 'animate-pulse rounded-[6px] bg-background-skeleton'
});

export default function LoadingCard({ card }: OwnProps) {
  const isFinance = card === CardType.Finance;

  return (
    <CardContainer
      className={cx(
        'items-center',
        isFinance ? 'min-h-[194px]' : 'min-h-[360px] m:min-h-[194px]'
      )}
    >
      <div className="grid grid-rows-[24px_1fr] gap-16">
        <LoadingBlock className="h-24 w-[128px]" />
        {isFinance ? (
          <div className="flex w-full flex-col gap-16 m:flex-row">
            <LoadingBlock className="h-[120px] w-full flex-shrink-0 m:hidden" />
            <div className="flex w-full flex-col gap-8">
              <LoadingBlock className="h-16 w-full" />
              <LoadingBlock className="h-16 w-1/4" />
            </div>
          </div>
        ) : (
          <div className="flex w-full flex-col gap-16 m:flex-row ">
            <LoadingBlock className="h-[120px] w-full flex-shrink-0 m:h-72 m:w-72" />
            <div className="flex w-full flex-col gap-8">
              <LoadingBlock className="h-16 w-full" />
              <LoadingBlock className="h-16 w-1/4" />
            </div>
          </div>
        )}
      </div>
      <LoadingBlock className="h-40 w-full" />
    </CardContainer>
  );
}
